// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2haoC","right":"Footer_right__2Neg9","buttons":"Footer_buttons__Hl2FD"};